import { msg } from '../../i18n/msg';

/**
 * Слайды онбординга (макет «Datum Empire — новый онбординг», EN + RU).
 *
 * Любая строка — либо обычный текст (не переводится), либо msg(ключ, английский дефолт) — переводы в i18n.
 * Поля слайда:
 *   image      — картинка 290×250 (public/onboarding/*)
 *   imageMode  — 'cover' (по умолчанию) | 'frame' (каркас героя: contain + lighten на радиальном фоне)
 *   tags       — ряд чипов в левом верхнем углу картинки ({ text, tone: 'purple' | 'gold' })
 *   pins       — чипы с абсолютной позицией (подписи частей героя): { text, tone, style }
 *   highlight  — золотой чип «ТОП-3 · 1 000 GRAM»: { label, value }
 *   badge      — плашка справа снизу: { icon, text, tone? }, icon — путь к картинке или имя SVG из OnboardingIcon
 *   lairBar    — нижняя панель слайда «Миссии»: { icons[], title, sub }
 *   title, description
 *   features   — сетка 2×2 под текстом (может отсутствовать): [{ icon, text, color? }]
 *                первая карточка подсвечена лаймовой рамкой
 */

const ICON_TICKET = '/onboarding/icon-ticket.jpg';
const ICON_COIN = '/onboarding/icon-coin.jpg';
const ICON_GRAM = '/onboarding/icon-gram.jpg';

const LIME = '#c8ff2e';
const PURPLE = '#a99bff';
const GOLD = '#ffd23f';

export const ONBOARDING_BUTTONS = {
  next: msg('onboarding.button.next', 'Next'),
  start: msg('onboarding.button.start', 'Start Playing'),
  loading: msg('common.loading', 'Loading…'),
  header: msg('onboarding.header', 'Onboarding'),
};

export const onboardingSlides = [
  {
    id: 'hero',
    image: '/onboarding/hero.jpg',
    imageMode: 'frame',
    pins: [
      { text: msg('onboarding.hero.pin_head', 'HEAD'), tone: 'lime', style: { left: 14, top: '13.6%' } },
      { text: msg('onboarding.hero.pin_arms', 'ARMS'), tone: 'purple', style: { right: 14, top: '32.8%' } },
      { text: msg('onboarding.hero.pin_body', 'BODY'), tone: 'purple', style: { left: 14, top: '52.8%' } },
    ],
    badge: { icon: 'star', text: msg('onboarding.hero.badge', 'Free Hero') },
    title: msg('onboarding.hero.title', 'Build Your Hero'),
    description: msg('onboarding.hero.description',
      'Your first hero is free.\nCollect modules and merge duplicates to make your hero stronger.'),
    features: [
      { icon: 'star', color: LIME, text: msg('onboarding.hero.feature_free', 'Free hero') },
      { icon: 'modules', color: PURPLE, text: msg('onboarding.hero.feature_modules', 'Modules for every body part') },
      { icon: 'merge', color: PURPLE, text: msg('onboarding.hero.feature_merge', 'Merge duplicates') },
      { icon: 'growth', color: GOLD, text: msg('onboarding.hero.feature_growth', 'Power grows with level') },
    ],
  },
  {
    id: 'spin',
    image: '/onboarding/spin.jpg',
    imagePosition: '50% 30%',
    tags: [{ text: msg('onboarding.spin.tag_pass', 'Season Pass +1'), tone: 'gold' }],
    badge: { icon: ICON_TICKET, text: msg('onboarding.spin.badge', 'Lucky Spin') },
    title: msg('onboarding.spin.title', 'Spin for Hero Parts'),
    description: msg('onboarding.spin.description',
      'Use tickets to win hero modules, coins and chests with GRAM. Every spin advances your Season Pass.'),
    features: [
      { icon: 'modules', color: LIME, text: msg('onboarding.spin.feature_modules', 'Hero modules') },
      { icon: ICON_GRAM, text: msg('onboarding.spin.feature_chests', 'Chests with GRAM') },
      { icon: ICON_COIN, round: true, text: msg('onboarding.spin.feature_coins', 'Coins') },
      { icon: 'shield', color: GOLD, text: msg('onboarding.spin.feature_pass', 'Season Pass progress') },
    ],
  },
  {
    id: 'missions',
    image: '/onboarding/missions.jpg',
    tags: [
      { text: msg('onboarding.missions.tag_match3', 'Match-3') },
      { text: msg('onboarding.missions.tag_solitaire', 'Solitaire') },
      { text: msg('onboarding.missions.tag_expeditions', 'Expeditions') },
    ],
    lairBar: {
      icons: ['/onboarding/lair-1.jpg', '/onboarding/lair-2.jpg', '/onboarding/lair-3.jpg', '/onboarding/lair-4.jpg'],
      title: msg('onboarding.missions.lair_title', 'Lair'),
      sub: msg('onboarding.missions.lair_sub', 'every 2h'),
    },
    title: msg('onboarding.missions.title', 'Missions & Lair'),
    description: msg('onboarding.missions.description',
      'Play mini-games and send your hero on expeditions. Lair buildings earn coins even while you rest.'),
    features: [
      { icon: 'cards', color: LIME, text: msg('onboarding.missions.feature_games', 'Match-3 and Solitaire') },
      { icon: 'compass', color: PURPLE, text: msg('onboarding.missions.feature_expeditions', 'Hero expeditions') },
      { icon: ICON_GRAM, text: msg('onboarding.missions.feature_loot', 'Rare loot') },
      { icon: ICON_COIN, round: true, text: msg('onboarding.missions.feature_coins', 'Coins every 2 hours') },
    ],
  },
  {
    id: 'pvp',
    image: '/onboarding/pvp.jpg',
    tags: [
      { text: msg('onboarding.pvp.tag_arena', 'Arena 1v1') },
      { text: msg('onboarding.pvp.tag_durak', 'Durak') },
    ],
    badge: { icon: ICON_GRAM, text: 'PvP' },
    title: msg('onboarding.pvp.title', 'Fight Real Players'),
    description: msg('onboarding.pvp.description',
      'Real-time hero duels and online Durak. Train for free — with DatumPass, play for GRAM.'),
    features: [
      { icon: 'swords', color: LIME, text: msg('onboarding.pvp.feature_duels', '1v1 duels') },
      { icon: 'cards', color: PURPLE, text: msg('onboarding.pvp.feature_durak', 'Online Durak') },
      { icon: 'shield', color: PURPLE, text: msg('onboarding.pvp.feature_training', 'Free training') },
      { icon: ICON_GRAM, text: msg('onboarding.pvp.feature_gram', 'Play for GRAM') },
    ],
  },
  {
    id: 'leaderboard',
    image: '/onboarding/leaderboard.jpg',
    highlight: {
      label: msg('onboarding.leaderboard.highlight_label', 'TOP 3'),
      value: msg('onboarding.leaderboard.highlight_value', '1,000 GRAM'),
    },
    badge: { icon: ICON_GRAM, text: msg('onboarding.leaderboard.badge', 'Season Top') },
    title: msg('onboarding.leaderboard.title', 'Climb the Season Leaderboard'),
    description: msg('onboarding.leaderboard.description',
      'Every spin earns rating points. At the end of the season the best players get rewards.'),
    features: [
      { icon: ICON_GRAM, text: msg('onboarding.leaderboard.feature_top3', 'Top 3 share 1,000 GRAM') },
      { icon: ICON_COIN, round: true, text: msg('onboarding.leaderboard.feature_top1000', 'Places 4–1,000: 10,000 coins') },
      { icon: ICON_COIN, round: true, text: msg('onboarding.leaderboard.feature_top10000', 'Up to place 10,000: 5,000 coins') },
      { icon: 'growth', color: GOLD, text: msg('onboarding.leaderboard.feature_new_season', 'New season — new chance') },
    ],
  },
  {
    id: 'datumpass',
    image: '/onboarding/datumpass.jpg',
    badge: { icon: 'pass', text: 'DatumPass', tone: 'gold' },
    title: msg('onboarding.datumpass.title', 'Get DatumPass to Earn'),
    description: msg('onboarding.datumpass.description', 'Invite friends and earn GRAM from their purchases and wins.'),
    features: [
      { icon: ICON_GRAM, text: msg('onboarding.datumpass.feature_income', 'Income from friends') },
      { icon: 'swords', color: PURPLE, text: msg('onboarding.datumpass.feature_pvp', 'PvP for GRAM') },
      { icon: 'shield', color: GOLD, text: msg('onboarding.datumpass.feature_pass', 'Premium Season Pass') },
      { icon: ICON_TICKET, text: msg('onboarding.datumpass.feature_tickets', '2× free tickets') },
    ],
    footnote: msg('onboarding.datumpass.footnote', 'Each purchase adds 30 days · available anytime in the Shop'),
  },
];
